<template>
  <div>
    <router-link :to="to">{{caption}}</router-link>
  </div>
</template>

<script>
export default {
  name: 'CPanelAction',
  props: {
    caption: {
      type: String,
      required: true
    },
    to: {
      type: [String, Object],
      required: true
    }
  }
}
</script>
